import { GQLMerchItemFragment } from '@theprintbar/graphql';

export function merchInStock(merch: Pick<GQLMerchItemFragment, 'product'>, variants?: string[]): boolean {
	if (!merch.product.isSameday) return false;

	return variants?.length
		? variants.every(variant => !!merch.product.variants?.find(v => v.id === variant)?.warehouseStock?.some(s => !!s.quantity))
		: true;
}
